import JSONFormatter from 'json-formatter-js';
import "json-formatter-js/dist/json-formatter.css";
import './json-formatter.scss';

export interface IJsonFormatterProps {
    json?: any,
    expansionLevel?: number,
}

const JsonFormatter: React.FC<IJsonFormatterProps> = ({ json, expansionLevel }) => {
    const formatter = new JSONFormatter(json);

    formatter.openAtDepth(expansionLevel);

    return (<div className='js-format' ref={(ref) => {
        if (ref?.firstChild) ref?.removeChild(ref.firstChild);
        return json && Object.keys(json).length !== 0 ? ref?.appendChild(formatter.render()) : null
    }} />);
}

export default JsonFormatter;
